import { useSelector } from 'react-redux';
import { useThreadViewPublishing } from '../../publish-message-feature/public/hooks/useThreadViewPublishing';
import { getCurrentThreadId } from 'conversations-thread-data/thread-details/public/selectors';
import { jsx as _jsx } from "react/jsx-runtime";
export function withOnRepublish(WrappedComponent) {
  function ComponentWithRepublish(props) {
    const threadId = useSelector(getCurrentThreadId);
    const {
      republishMessage
    } = useThreadViewPublishing({
      threadId: `${threadId}`
    });
    return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props, {
      onRepublish: republishMessage
    }));
  }
  ComponentWithRepublish.displayName = `withOnRepublish(${WrappedComponent.displayName || 'UnknownComponent'})`;
  return ComponentWithRepublish;
}